var _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0374 16.9546L8.40271 13.2H6.92004V20.6666H8.82937V16.912L11.464 20.6666H12.936V13.2H11.0374V16.9546ZM14.3313 13.2V15.0453H16.1766V20.6666H18.086V15.0453H19.9313V13.2H14.3313Z",
    fill: "#F7AD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7V5C1 3.93913 1.42143 2.92172 2.17157 2.17157C2.92172 1.42143 3.93913 1 5 1H9",
    stroke: "#F7AD00",
    strokeWidth: 1.77122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27V29C1 30.0609 1.42143 31.0783 2.17157 31.8284C2.92172 32.5786 3.93913 33 5 33H9",
    stroke: "#F7AD00",
    strokeWidth: 1.77122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H29C30.0609 1 31.0783 1.42143 31.8284 2.17157C32.5786 2.92172 33 3.93913 33 5V7",
    stroke: "#F7AD00",
    strokeWidth: 1.77122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33H29C30.0609 33 31.0783 32.5786 31.8284 31.8284C32.5786 31.0783 33 30.0609 33 29V27",
    stroke: "#F7AD00",
    strokeWidth: 1.77122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.0195,
    y: 13,
    width: 4.62997,
    height: 4.62997,
    rx: 2.31498,
    fill: "#414141"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3334 20.7819C22.3334 19.0199 23.7617 17.5916 25.5237 17.5916C27.2857 17.5916 28.714 19.0199 28.714 20.7819V21.2862C28.714 21.4223 28.6038 21.5326 28.4677 21.5326H22.5797C22.4437 21.5326 22.3334 21.4223 22.3334 21.2862V20.7819Z",
    fill: "#414141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 12.4352,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6787,
    y: 5,
    width: 2.6114,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6787,
    y: 22.5337,
    width: 2.6114,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.85498,
    width: 2.6114,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.97925,
    y: 8.85498,
    width: 12.3109,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5336,
    y: 8.91711,
    width: 7.21243,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26.3885,
    width: 2.6114,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.97925,
    y: 26.3885,
    width: 12.3109,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5336,
    y: 5,
    width: 7.21243,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5336,
    y: 22.5337,
    width: 7.21243,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22.5958,
    width: 12.4352,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5336,
    y: 26.3885,
    width: 7.21243,
    height: 2.6114,
    rx: 1.3057,
    fill: "#414141"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.0cc4053d0d710c315cbd1e157bac9d83.svg";
export { ForwardRef as ReactComponent };